import { Translator } from '../Translator';
import { translate } from './translate';
import { BUTTON_FOR_MULTIMEDIA2 } from '~/training/sequence/templates/items';

export const Multimedia2: Translator = sequence => {
  const root =  translate(sequence, () => {
    return null;
  });

  root?.items?.push({
    type: BUTTON_FOR_MULTIMEDIA2,
    id: 'play_btn',
    values: {},
    items: []
  });

  return root;
};

